import {AppClientTokens} from "../types.ts";

export const buildBrokerReturnForm = (brokerBaseUrl: string, request: string, tokens: AppClientTokens) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${brokerBaseUrl}/handoff/complete`;
    form.enctype = 'application/x-www-form-urlencoded';
    form.style.display = 'none';

    const fields: [string, string][] = [
        ['request', request],
        ['id_token', tokens.idToken],
        ['access_token', tokens.accessToken],
        ['refresh_token', tokens.refreshToken],
    ];

    for (const [name, value] of fields) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    return form;
};

export const returnToBroker = (brokerBaseUrl: string, request: string, tokens: AppClientTokens) => {
    const form = buildBrokerReturnForm(brokerBaseUrl, request, tokens);
    document.body.appendChild(form);
    form.submit();
};
